export const ZOOM_STEP = 10
export const ZOOM_MIN = 10
export const ZOOM_MAX = 300
